import React from "react";
import { useSelector } from "react-redux";

const AuthThree = () => {
  const locale = useSelector((state) => state.theme.locale);

  return (
    <div
      className="flex-1 flex flex-col items-center justify-center bg-no-repeat bg-cover text-center p-5"
      style={{ backgroundImage: `url('/img/auth/3.jpg')` }}
    >
      <img
        className="mb-10"
        alt="Woman Social Impact"
        src="/img/auth/splash.png"
      />
      {locale === "en" ? (
        <p className="mb-10 text-[40px] text-white leading-snug">
          2023 <br />
          Turkey's Woman Social Impact <br /> Entrepreneur
        </p>
      ) : (
        <p className="mb-10 text-[40px] text-white leading-snug">
          2023 Yılı <br />
          Türkiye'nin Kadın Sosyal Etki <br /> Girişimcisi
        </p>
      )}
      <h1 className="mb-8 text-white">Müge Baltacı</h1>
    </div>
  );
};

export default AuthThree;
